import NextLink from 'next/link'
import { Breadcrumbs, BreadcrumbsProps, Link, Typography } from '@mui/material'

export type BreadcrumbItem = {
  label: string
  href?: string
}

type BreadcrumbTrailProps = Omit<BreadcrumbsProps, 'children'> & {
  items: BreadcrumbItem[]
}

export function BreadcrumbTrail({ items, ...props }: BreadcrumbTrailProps) {
  return (
    <Breadcrumbs separator=">" aria-label="Breadcrumb" {...props}>
      {items.map(({ label, href }) =>
        href ? (
          <Link
            component={NextLink}
            href={href}
            color="inherit"
            underline="hover"
            key={`${href}-${label}`}
          >
            {label}
          </Link>
        ) : (
          <Typography color="inherit" key={`${label}-current`}>
            {label}
          </Typography>
        )
      )}
    </Breadcrumbs>
  )
}
